// extracted by css-extract-rspack-plugin
export default {"surface":"surface-cM0veB"};